__turbopack_context__.v({
  "cta": "AnalysisRecommendations-module__nqA24a__cta",
  "list": "AnalysisRecommendations-module__nqA24a__list",
  "listWrapper": "AnalysisRecommendations-module__nqA24a__listWrapper",
  "nextCard": "AnalysisRecommendations-module__nqA24a__nextCard",
  "overlay": "AnalysisRecommendations-module__nqA24a__overlay",
  "placeholder": "AnalysisRecommendations-module__nqA24a__placeholder",
  "recommendationList": "AnalysisRecommendations-module__nqA24a__recommendationList",
});
